/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './toast.scss';

import Toast from './toast.service';
import ToastController from './toast.controller';

export default angular.module('tektelic.toast', [])
    .factory('toast', Toast)
    .controller('ToastController', ToastController)
    .name;



// WEBPACK FOOTER //
// ./src/app/services/toast.js